(function() {
  'use strict';

  angular.module('component.bulkActions')
    .component('bulkActionCreateOrEditComponent', {
      templateUrl: 'app/components/bulk-actions/bulk-action-create-or-edit.html',
      controller: 'BulkActionCreateOrEditController',
      controllerAs: 'bulkActionCtrl',
      bindings: {
        bulkActionId: '<'
      }
    });
})();
